import { render, staticRenderFns } from "./SkupTema2Create.vue?vue&type=template&id=491eec85&scoped=true&"
import script from "./SkupTema2Create.vue?vue&type=script&lang=js&"
export * from "./SkupTema2Create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491eec85",
  null
  
)

export default component.exports